module.exports = __webpack_public_path__ + "static/media/Bluelab PowerPod.8e1858a9.webp";